import {
  faAngleRight,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import style from "./MyPageLayout.module.css";
import coupon from "resources/img/icons/coupon.png";
import point from "resources/img/icons/point.png";
import listData from "InitialData/accounts/listData.json";
import { NavLink, Outlet, useNavigate, useParams } from "react-router-dom";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useState } from "react";
import Center from "layouts/wrapper/Center";
import NiceModal from "@ebay/nice-modal-react";
import { AuthContext } from "providers/AuthProvider";
import { requester } from "App";
import { useTranslation } from "react-i18next";
import MypageContentHeader from "./header/MypageContentHeader";
import AnimatedSwitch from "components/AnimatedSwitch";
import PartnerLinkDisplay from "./partners/PartnerLinkDisplay";
import AccountNo from "routes/front/main/productList/AccountNo";
import HighlightedText from "components/inputs/HighlightedText";
import Dummy from "components/Dummy";

function MyPageLayout() {
  const { isMobile } = useContext(BrowserDetectContext);
  const { userName, userInfo } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isUserInfo, setUserInfo] = useState();
  const { t } = useTranslation();

  useEffect(() => {
    if (userInfo) {
      setUserInfo(userInfo);
    }
  }, [userInfo])

  const onClick = () => {
    navigate("/mypage");
  };
  const SideMenu = ({ data }) => {
    const [active, setActive] = useState(false);
    const color = active ? "var(--main-color)" : "black";
  
    if (data.type === "modal") {
      return (
        <div 
        onClick={() => NiceModal.show(data.modalName, { isForced: data.isForced })}
        style={{ cursor: 'pointer' }}
      >
        <P size={"10pt"} padding={"0 0 5px 0"} color={"black"}>
          {t(data.row)}
        </P>
      </div>
      );
    }
  
    return (
      <NavLink
        to={data.to ? data.to : ""}
        end
        style={({ isActive }) => {
          setActive(isActive);
        }}
        replace={true}
      >
        <P size={"10pt"} padding={"0 0 5px 0"} color={color}>
          {t(data.row)}
        </P>
      </NavLink>
    );
  };

  return (
    <Container maxWidth={1200} minWidth={!isMobile && 1200}>
      {isMobile ? (
        <div className={style.mobile}>
          <VerticalFlex>
            <FlexChild>
              <Outlet />
            </FlexChild>
          </VerticalFlex>
        </div>
      ) : (
        <VerticalFlex margin={"60px 0 0 0"}>
          <FlexChild alignItems={"flex-start"}>
            <HorizontalFlex alignItems={"flex-start"}>
              <FlexChild width={"15%"}>
                <div onClick={onClick} className={style.title}>
                  <P size={"var(--font-size-lg)"}>MY&nbsp;PAGE</P>
                </div>
              </FlexChild>
              <FlexChild justifyContent={"flex-start"}>
                <div className={style.header}>
                  <HorizontalFlex>
                    <FlexChild padding={"0 0 0 15px"}>
                      <div>
                        <P
                          size={"11pt"}
                          color={"var(--main-color)"}
                          weight={"bold"}
                        >
                          WELCOME <FontAwesomeIcon icon={faAngleRight} />
                        </P>
                        <div className={style.userWelcome}>
                          <P weight={"bold"} color={"var(--main-color)"}>
                            {isUserInfo?.first_name} {isUserInfo?.groups[0]?.name}&nbsp;
                          </P>
                          <P weight={"bold"}>님&nbsp;{t("hello")}</P>
                        </div>
                        <P weight={"bold"}>
                          <HighlightedText
                          text={""}
                            // text={`가상계좌 : ${isUserInfo?.metadata?.account} ${isUserInfo?.metadata?.bank}`}
                            highlights={[`가상계좌`]}
                            highlightColor="var(--main-color)"
                          />
                        </P>
                        <P weight={"bold"}>
                        <HighlightedText
                        text={""}
                            // text={`예금주 : ${isUserInfo?.metadata?.owner}`}
                            highlights={['예금주']}
                            highlightColor="var(--main-color)"
                          />
                        </P>
                      </div>
                    </FlexChild>
                    <FlexChild>
                      {/* <PartnerLinkDisplay userInfo={isUserInfo} /> */}
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={50} justifyContent={"flex-end"}>
                        <FlexChild
                          width={"max-content"}
                          padding={"10px 10px 0 0"}
                        >
                          <div className={style.pointWrap}>
                            <VerticalFlex gap={5}>
                              <FlexChild>
                                <img src={point} className={style.pointImg} />
                                <P
                                  color={"var(--font-faint-color)"}
                                  size={"10pt"}
                                >
                                  {t("point")}
                                </P>
                              </FlexChild>
                              <FlexChild>
                                <P
                                  weight={"bold"}
                                  size={"14pt"}
                                  color={"var(--main-color)"}
                                >
                                  {isUserInfo?.point}
                                </P>
                              </FlexChild>
                            </VerticalFlex>
                          </div>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                  </HorizontalFlex>
                </div>
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex alignItems={"flex-start"}>
              <FlexChild width={"15%"}>
                <div className={style.wrap}>
                  <VerticalFlex flexStart>
                    {listData &&
                      listData.map((data, index) => (
                        <FlexChild key={index}>
                          <div className={style.padding}>
                            {data.blocks &&
                              data.blocks.map((block, index) => (
                                <div key={index}>
                                  {block.contents &&
                                    block.contents.map((row, index) => (
                                      <SideMenu key={index} data={row} />
                                    ))}
                                </div>
                              ))}
                          </div>
                        </FlexChild>
                      ))}
                  </VerticalFlex>
                </div>
              </FlexChild>
              <FlexChild height={"100%"}>
                <MypageContentHeader>
                  <Outlet />
                </MypageContentHeader>
              </FlexChild>
            </HorizontalFlex>
            <Dummy height={50}/>
          </FlexChild>
        </VerticalFlex>
      )}
    </Container>
  );
}

export default MyPageLayout;
